import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// import DeleteMenuEventTextButton from '../atoms/DeleteMenuEventTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textDelete: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  },
  menuImage: {
    width: 100,
    height: 63,
    objectFit: 'cover'
  },
  noImage: {
    width: 100,
    height: 63,
    backgroundColor: '#D1D1D1',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: '#A5A5A5',
    fontSize: 10
  },
  disabledMenu: {
    opacity: 0.5
  }
};

const propTypes = {
  ticket: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      menuName: PropTypes.string,
      createdAt: PropTypes.string,
      menuIncludedTaxPrice: PropTypes.number,
      quantity: PropTypes.number,
      chargeAmount: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({ ticket, emptyRows, page, rowsPerPage, order, orderBy }) => {
    const sortedResult = _.orderBy(ticket, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(ticketGochi => {
            const key = `${ticketGochi.budgetGochiId}`;
            return (
              <TableRow key={key} hover>
                <TableCell>
                  {(() => {
                    if (ticketGochi.status === 1)
                      return `${ticketGochi.gochiBillNo}`;
                    if (ticketGochi.status === 2) return '発行失敗';
                    return '処理中';
                  })()}
                </TableCell>
                <TableCell>{ticketGochi.menuId}</TableCell>
                <TableCell>{ticketGochi.menuName}</TableCell>
                <TableCell>{ticketGochi.createdAt}</TableCell>
                <TableCell>{ticketGochi.menuIncludedTaxPrice}</TableCell>
                <TableCell>{ticketGochi.quantity}</TableCell>
                <TableCell>{ticketGochi.chargeAmount}</TableCell>
                <TableCell>
                  {`${ticketGochi.year}/${ticketGochi.month}`}
                </TableCell>
                <TableCell>
                  {(() => {
                    if (ticketGochi.status === 1)
                      return `${ticketGochi.inviteUrl}`;
                    if (ticketGochi.status === 2) return '発行失敗';
                    return '処理中';
                  })()}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          // <TableRow style={{ height: 49 * emptyRows }}>
          //   <TableCell colSpan={7} />
          // </TableRow>
          <></>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
